import { useCallback, useMemo } from "react";
import { Input } from "antd";
import debounce from "lodash.debounce";
import { IconSearch } from "@tabler/icons-react";
import { AgGridReact } from "ag-grid-react";

type SearchInputProps = {
  placeholder?: string;
  gridRef: React.RefObject<AgGridReact<any>>;
  disabled?: boolean;
  onSearch?: (text: string) => void;
};

function CiqAgSearch(props: SearchInputProps) {
  const {
    gridRef,
    placeholder = "Search",
    disabled = false,
    onSearch = (text: string) => {
      gridRef.current?.api?.setGridOption("quickFilterText", text);
    }
  } = props;

  const debouncedSearch = useMemo(
    () =>
      debounce((text) => {
        onSearch(text);
      }, 500),
    [onSearch]
  );

  const handleChange = useCallback(
    (e: React.FormEvent) => {
      debouncedSearch((e.target as HTMLInputElement).value);
    },
    [debouncedSearch]
  );

  return (
    <div className="w-[225px] py-1">
      <Input
        type="text"
        placeholder={placeholder}
        suffix={<IconSearch size={14} />}
        onChange={handleChange}
        disabled={disabled || !gridRef.current?.api}
        data-testid="ciq-ag-search-input"
      />
    </div>
  );
}

export default CiqAgSearch;
